"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processDimensions = exports.getRawDimensionsFromEnv = exports.getRawDimensionsFromHeaders = exports.getCacheKeyForDimensions = exports.dimensionsToDimensionTuple = exports.dimensionTupleToDimensions = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const typing_1 = require("./typing");
function dimensionTupleToDimensions(...dimensionTuple) {
    const dimensions = {
        [typing_1.DimensionEnum.MODULE]: dimensionTuple[0],
        [typing_1.DimensionEnum.VERSION]: dimensionTuple[1],
        [typing_1.DimensionEnum.MARKET]: dimensionTuple[2],
        [typing_1.DimensionEnum.LANGUAGE]: dimensionTuple[3],
        [typing_1.DimensionEnum.BRAND_CODE]: dimensionTuple[4],
        [typing_1.DimensionEnum.BRAND]: typing_1.BrandCodeToBasicBrand[dimensionTuple[4]],
        [typing_1.DimensionEnum.CONTEXT]: dimensionTuple[5],
        [typing_1.DimensionEnum.ENV_NAME]: dimensionTuple[6],
    };
    return dimensions;
}
exports.dimensionTupleToDimensions = dimensionTupleToDimensions;
function dimensionsToDimensionTuple(dimensions) {
    return [
        dimensions[typing_1.DimensionEnum.MODULE],
        dimensions[typing_1.DimensionEnum.VERSION],
        dimensions[typing_1.DimensionEnum.MARKET],
        dimensions[typing_1.DimensionEnum.LANGUAGE],
        dimensions[typing_1.DimensionEnum.BRAND_CODE],
        dimensions[typing_1.DimensionEnum.CONTEXT],
        dimensions[typing_1.DimensionEnum.ENV_NAME],
    ];
}
exports.dimensionsToDimensionTuple = dimensionsToDimensionTuple;
function getCacheKeyForDimensions(dimensions) {
    if (dimensions.meaning === typing_1.MeaningEnum.FRONTEND) {
        return `ENV_FE_${dimensionsToDimensionTuple(dimensions).join('.')}`;
    }
    return `ENV_${dimensionsToDimensionTuple(dimensions).join('.')}`;
}
exports.getCacheKeyForDimensions = getCacheKeyForDimensions;
/**
 * Gets unprocessed dimensions from HTTP headers
 * @param headers headerName: headerValue keypair object
 */
function getRawDimensionsFromHeaders(headers) {
    const dimensions = {
        version: headers[typing_1.MMHeaders.API_VERSION],
        market: headers[typing_1.MMHeaders.MARKET],
        language: headers[typing_1.MMHeaders.LANGUAGE],
        envName: headers[typing_1.MMHeaders.ENV_NAME],
        context: headers[typing_1.MMHeaders.CONTEXT],
        brandCode: headers[typing_1.MMHeaders.BRAND_CODE],
    };
    return dimensions;
}
exports.getRawDimensionsFromHeaders = getRawDimensionsFromHeaders;
/**
 * Gets unprocessed dimensions from dimension environment variables
 * @param env env object supplied else taken from window.process.env or global.process.env
 */
function getRawDimensionsFromEnv(env) {
    var _a;
    if (env === void 0) { env = (_a = window_or_global_1.default
        .process) === null || _a === void 0 ? void 0 : _a.env; }
    if (!env) {
        throw new Error('Please supply environments as object');
    }
    const dimensions = {
        version: env[typing_1.MMEnvironmentVariables.API_VERSION],
        market: env[typing_1.MMEnvironmentVariables.MARKET],
        language: env[typing_1.MMEnvironmentVariables.LANGUAGE],
        envName: env[typing_1.MMEnvironmentVariables.ENV_NAME],
        context: env[typing_1.MMEnvironmentVariables.CONTEXT],
        brandCode: env[typing_1.MMEnvironmentVariables.BRAND_CODE],
    };
    return dimensions;
}
exports.getRawDimensionsFromEnv = getRawDimensionsFromEnv;
/**
 * Tries to guess or assings defaults to missing dimensions
 * @param dimensions partial dimensions
 */
function processDimensions(dimensions) {
    dimensions = Object.assign({}, dimensions);
    if (!dimensions.brandCode &&
        dimensions.brand &&
        typing_1.BasicBrandToBrandCode[dimensions.brand]) {
        dimensions.brandCode = typing_1.BasicBrandToBrandCode[dimensions.brand];
    }
    if (!dimensions.brand &&
        dimensions.brandCode &&
        typing_1.BrandCodeToBasicBrand[dimensions.brandCode]) {
        dimensions.brand = typing_1.BrandCodeToBasicBrand[dimensions.brandCode];
    }
    if (dimensions.module && !dimensions.version) {
        dimensions.version = typing_1.DefaultApiVersions[dimensions.module];
    }
    if (!dimensions.context) {
        dimensions.context = typing_1.ContextEnum.DEFAULT;
    }
    if (dimensions.brandCode === typing_1.BrandCodeEnum.VAUXHALL && dimensions.market !== typing_1.MarketEnum.GB) {
        dimensions.brand = typing_1.BasicBrandEnum.OPEL;
    }
    return dimensions;
}
exports.processDimensions = processDimensions;
